<template>
  <div class="search-view">
    <div class="search-header">
      <h1 class="search-title">
        <span v-if="searchQuery">Resultados para: "{{ searchQuery }}"</span>
        <span v-else>Buscar Notícias</span>
      </h1>
      <p class="search-count" v-if="searchQuery && !isLoading">
        {{ searchResults.length }} {{ searchResults.length === 1 ? 'resultado encontrado' : 'resultados encontrados' }}
      </p>
    </div>

    <div v-if="fetchError" class="no-results">
      <Icon icon="material-symbols:error-outline-rounded" class="no-results-icon" />
      <h2>{{ fetchError }}</h2>
      <p>Tente recarregar a página em alguns instantes.</p>
      <button class="retry-btn" @click="fetchAllNews">Tentar novamente</button>
    </div>

    <div v-else-if="isLoading" class="loading-container">
      <div class="loading-spinner"></div>
      <p class="loading-text">Buscando notícias...</p>
    </div>
    
    <NewsGrid 
      v-else-if="searchResults.length > 0"
      :news="searchResults" 
      :category="null"
      :title="null"
    />
    
    <div v-else-if="searchQuery" class="no-results">
      <Icon icon="material-symbols:search-off-rounded" class="no-results-icon" />
      <h2>Nenhum resultado encontrado</h2>
      <p>Tente buscar com outras palavras-chave</p>
    </div>
    
    <div v-else class="search-placeholder">
      <Icon icon="material-symbols:search-rounded" class="placeholder-icon" />
      <h2>Digite algo para buscar</h2>
      <p>Use o campo de busca no menu para encontrar notícias</p>
    </div>
  </div>
</template>

<script>
import { Icon } from '@iconify/vue';
import NewsGrid from '../components/NewsGrid.vue';
import { getAllNews } from '../data/newsData';

export default {
  name: 'SearchView',
  components: {
    Icon,
    NewsGrid
  },
  data() {
    return {
      searchQuery: '',
      allNews: [],
      isLoading: false,
      fetchError: ''
    }
  },
  computed: {
    searchResults() {
      if (!this.searchQuery) return [];
      
      const query = this.searchQuery.toLowerCase();
      return this.allNews.filter(article => {
        return (
          article.title.toLowerCase().includes(query) ||
          article.excerpt.toLowerCase().includes(query) ||
          article.category.toLowerCase().includes(query) ||
          (article.subtitle && article.subtitle.toLowerCase().includes(query))
        );
      });
    }
  },
  watch: {
    '$route.query.q': {
      immediate: true,
      handler(newQuery) {
        this.isLoading = true;
        this.searchQuery = newQuery || '';

        setTimeout(() => {
          this.isLoading = false;
        }, 300);
      }
    }
  },
  created() {
    this.fetchAllNews()
  },
  methods: {
    async fetchAllNews() {
      this.fetchError = ''
      try {
        this.allNews = await getAllNews() || []
      } catch (error) {
        console.error('Erro ao carregar notícias para busca', error)
        this.allNews = []
        this.fetchError = 'Não foi possível carregar o conteúdo no momento.'
      }
    }
  }
}
</script>

<style scoped>
.search-view {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1rem;
  min-height: 60vh;
}

.search-header {
  text-align: center;
  margin-bottom: 3rem;
}

.search-title {
  font-size: 40px;
  margin-bottom: 1rem;
  color: var(--brand-cloud);
  font-weight: 800;
  letter-spacing: -1px;
}

.search-count {
  color: rgba(229, 233, 253, 0.75);
  font-size: 18px;
}

.no-results,
.search-placeholder {
  text-align: center;
  padding: 4rem 2rem;
  background: transparent;
  border-radius: 16px;
  border: none;
}

.no-results-icon,
.placeholder-icon {
  font-size: 80px;
  color: rgba(148, 171, 249, 0.45);
  margin-bottom: 1.5rem;
}

.no-results h2,
.search-placeholder h2 {
  color: var(--brand-cloud);
  font-size: 29px;
  margin-bottom: 1rem;
}

.no-results p,
.search-placeholder p {
  color: rgba(229, 233, 253, 0.75);
  font-size: 18px;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5rem 2rem;
  gap: 1.5rem;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(149, 171, 249, 0.25);
  border-top-color: #94abf9;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.loading-text {
  color: rgba(229, 233, 253, 0.75);
  font-size: 18px;
  font-weight: 500;
}

.retry-btn {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
  padding: 0.8rem 1.8rem;
  border: 1px solid rgba(229, 233, 253, 0.65);
  border-radius: 999px;
  background: var(--brand-navy);
  color: #f5f8ff;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 18px 35px rgba(0, 35, 73, 0.25);
}

.retry-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 24px 45px rgba(0, 35, 73, 0.32);
}

@media (max-width: 768px) {
  .search-title {
    font-size: 29px;
  }
  
  .search-count {
    font-size: 16px;
  }
  
  .no-results-icon,
  .placeholder-icon {
    font-size: 4rem;
  }
  
  .no-results h2,
  .search-placeholder h2 {
    font-size: 24px;
  }
}
</style>
